export const cek401 = {
    methods: {
        cekAuth() {
            localStorage.removeItem('BUMD_token')
            localStorage.removeItem('roleArr')
            localStorage.removeItem('user')
            localStorage.removeItem('permissons')
            this.$router.push({ name: 'Login' })
        }
    }
}

export default cek401